import React from 'react';
import LooksTutorial from './index';
import content from 'Content/content.json';
import { language } from 'Root/constants';

const download = true;

const DownloadLookTutorialPdf = ({ match }) => {
  const lens = content.data.productinfo[language];

  return (
    <LooksTutorial
      lens={lens}
      look={match.params.lookName}
      download={download}
      lensSelected={match.params.lensName}
    />
  );
};
export default DownloadLookTutorialPdf;
